import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from './reportWebVitals';
// import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));




root.render(
    <GoogleOAuthProvider clientId='39471930059-14dvscil4qplseoeu3lqncvtp85tt6rg.apps.googleusercontent.com'>
    <React.StrictMode>
        <App />
    </React.StrictMode>
    </GoogleOAuthProvider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
